<template>
  <div class="contactTypesActions">
    <VButton
      v-if="hasAnyMobileContact"
      id="select-sms-contact-type"
      text="Validar por SMS"
      variant="primary"
      size="lg"
      @click.native="validateBySMS"
    >
      <span>
        <SmsSvg class="selectContact__mailIcon" />
        Validar por SMS
      </span>
    </VButton>

    <VButton
      v-if="hasAnyEmailContact"
      id="select-email-contact-type"
      text="Validar por e-mail"
      variant="secondary"
      @click.native="validateByEmail"
    >
      <span>
        <MailSvg class="selectContact__mailIcon" />
        Validar por email
      </span>
    </VButton>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'ContactTypesActions',

  computed: {
    ...mapState({
      maskedContacts: ({ mdm }) => mdm.data.maskedContacts,
    }),

    hasAnyMobileContact() {
      const listOfPhones = this.maskedContacts?.mobilePhoneList;

      return !!listOfPhones?.length;
    },

    hasAnyEmailContact() {
      const listOfEmails = this.maskedContacts?.emailList;
      return !!listOfEmails?.length;
    },
  },

  methods: {
    ...mapMutations(['SET_VALIDATION_CONTACT_TYPE']),

    validateByEmail() {
      this.setContactType('email');
    },
    validateBySMS() {
      this.setContactType('sms');
    },

    async setContactType(contactType) {
      await this.SET_VALIDATION_CONTACT_TYPE(contactType);

      this.$emit('run-select-contact-flow', contactType);
    },
  },
};
</script>

<style lang="scss" scoped>
.contactTypesActions {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  .button-component {
    span {
      display: flex;
      font-weight: 600;
      justify-content: center;
      line-height: 1.4;
      text-align: center;
      width: 100%;
    }

    svg {
      margin-right: 10px;
      max-height: 20px;
    }

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &.button {
      &--secondary {
        span {
          color: var(--color-button-primary);
        }
        svg {
          path {
            fill: var(--color-button-primary);
          }
        }
      }

      &--primary {
        svg {
          path {
            fill: #fff;
          }
        }
      }
    }
  }
}
</style>
